import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { putData } from "../../../Core/Projects/action";
import { changeData, unchangeData } from '../../../Core/ChangeValues/action';
import { getPhotographersEq } from '../../../Core/Photogrphers/action';
import Star from './Star';
import Loader from '../../Loader';
import styles from '../../../Assets/Styles/Components/Book/Photograpers/card.module.css';
import Equipment from './Equipment';
import cam from '../../../Assets/Images/Equipment/camera.svg';
import lens from '../../../Assets/Images/Equipment/lens.svg';
import light from '../../../Assets/Images/Equipment/flash.svg';

class Card extends Component {
    emImgs = (images) => () => {
        this.props.onClick(images);
    }

    showCms = (id) => (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onComments(id);
    }

    returnId = (id) => () => {
        const { slug, data } = this.props.project;
        this.props.putData(slug, { ...data, photographer_uid: id, step: this.props.history.location.pathname.slice(1).split('/')[1] });
    }

    phEq = (id) => {
        this.props.getPhotographersEq(id);
    }

    render() {
        const { photographer_uid, display_name, avatar, rate, price, attachments, stduio_address_detail, studio_photos, grade_order, distance_to_you, photos, feed_backs_count, equipment, package_price, package_original_price, active_coupon_value, active_coupon_capacity, qrate, arate, finished_projects_count, rrate, grade, package_percent, area_name, market_experience, actual_experience_years } = this.props.data;
        const { isStudio, idComments, photographerSelected } = this.props;

        const properForText = () => {
            if (grade_order >= 5) {
                return "کم‌ریسک‌ترین انتخاب";
            }
            if (grade_order >= 3) {
                return "بهترین تعادل کیفیت و قیمت";
            }
            return "انتخاب اقتصادی با کیفیت قابل قبول";
        };

        const tradeoffText = () => {
            const years = actual_experience_years;
            const yearsText = years ? `${years} سال تجربه` : market_experience;
            return `${finished_projects_count} سفارش موفق • ${yearsText} • ${properForText()}`;
        };

        const stars = [];
        for (let i = 0; i < grade_order; i++) {
            stars.push(<i className="fa fa-star" aria-hidden="true" key={i} />);
        }

        return (
            <>
                <div className={`container ${styles.card}`}>
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-4 ">
                            <div className="row">
                                <div className={`col-5 col-md-5 col-lg-5 ${styles.photographerInfo}`}>
                                    {this.props.isRecommended && (
                                        <div className={styles.recommendedBadgeInline}>
                                            <span role="img" aria-label="پیشنهاد کادرو">🏅</span> پیشنهاد کادرو
                                        </div>
                                    )}
                                    <h3 className={styles.phName}> {isStudio && 'آتلیه '} {display_name} </h3>
                                    <div className={styles.photographerAvatarContainer}>
                                        <div className={styles.mainAvatar}>
                                            <img className={styles.circelAvatar} src={`https://kadro.co/${avatar.thumb}`} alt="" />
                                        </div> {
                                            attachments && (
                                                <div className={styles.avatars} onClick={this.emImgs(attachments)}>
                                                    <div className={styles.otherAvatars}>
                                                        {
                                                            attachments.slice(0, 2).map((ava, index) => (
                                                                <div
                                                                    className={styles.imgContainer}
                                                                    style={{ right: `${index * 1.5}em` }}
                                                                    key={ava.thumb}
                                                                >
                                                                    <img src={`https://kadro.co/${ava.thumb}`} alt="" />
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <p className={styles.badgeP}>
                                        {stars}
                                    </p>
                                    {!isStudio && this.props.project.data.skip_location && <div className={styles.areaName}>{this.props.project.data.city_name}، {area_name} </div>}
                                </div>
                                <div className={`col ${styles.commentsBox}`}>
                                    <p className={styles.commentsTitle}>دیدگاه کاربران</p>
                                    <div className={styles.ratingRow}>
                                        <p className={styles.ratingItem}>کیفیت <span className={styles.yellow}>{qrate}</span></p>
                                        <p className={styles.ratingItem}>برخورد <span className={styles.yellow}>{arate}</span></p>
                                    </div>
                                    <p className={styles.marketExperience}>
                                        {finished_projects_count > 10 ? (
                                            `از ${finished_projects_count} سفارش موفق`
                                        ) : (
                                            <span style={{ display: "block", fontSize: "12px", opacity: 0.8 }}>
                                                {market_experience}
                                            </span>
                                        )}
                                    </p>
                                    <br />
                                    <div className={styles.actionsRow}>
                                        {feed_backs_count !== 0 && (
                                            <div
                                                className={styles.tertiaryBtn}
                                                onClick={feed_backs_count !== 0 && this.showCms(photographer_uid)}
                                            >
                                                {idComments === photographer_uid ? <Loader scale="0.5" position="start" /> : (
                                                    <>
                                                        <span className={styles.hideOnMobile}>مشاهده </span>نظرات
                                                    </>
                                                )}
                                            </div>
                                        )}
                                        <a
                                            href={`https://www.kadro.co/pro/${photographer_uid}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={styles.fullProfileLink}
                                        >
                                            <span className={styles.hideOnMobile}>مشاهده </span>پروفایل{" "}
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="14"
                                                height="14"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                aria-hidden="true"
                                                style={{ verticalAlign: 'middle' }}
                                            >
                                                <path d="M18 13v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                                <polyline points="15 3 21 3 21 9" />
                                                <line x1="10" y1="14" x2="21" y2="3" />
                                            </svg>
                                        </a>
                                    </div>
                                    <br />
                                    <div className={`${styles.eqsBox} ${styles.eqsBoxMobile}`}>
                                        <div className={styles.thumbnails}>
                                            <Equipment
                                                eq={equipment}
                                                name={display_name}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`col-12 col-md-6 col-lg-4 ${styles.mediaRow}`}>
                            <div className={styles.imagesBox}>
                                <p> </p>
                                <div className={styles.thumbnails} onClick={this.emImgs(photos)}>
                                    {photos?.slice(0, 3).map((item) =>
                                        <img alt="نمونه کار" key={`${item.thumb} نمونه کارها`} src={`https://kadro.co/${item.thumb}`} />
                                    )}
                                    {photos?.slice(3, 5).map((item) =>
                                        <img className={styles.mobileExtraThumb} alt="نمونه کار" key={`${item.thumb} نمونه کارها`} src={`https://kadro.co/${item.thumb}`} />
                                    )}
                                    {
                                        photos.length > 3 &&
                                        <div className={styles.exImages}>
                                                <b> مشاهده {(photos?.length)} نمونه کار</b>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className={`${styles.eqsBox} ${styles.eqsBoxDesktop}`}>
                                <p> </p>
                                <div className={styles.thumbnails}>
                                    <Equipment
                                        eq={equipment}
                                        name={display_name}
                                    />
                                </div>
                            </div>
                            {
                                isStudio && studio_photos && studio_photos.length !== 0 &&
                                <div className={styles.imagesBox}>
                                    <p> </p>
                                    <div
                                        className={styles.thumbnails}
                                        onClick={this.emImgs(studio_photos)}
                                    > {
                                            studio_photos.slice(0, 3).map((item) =>
                                                <img
                                                    alt={`${item.thumb} آتلیه`}
                                                    key={`${item.thumb} آتلیه`}
                                                    src={`https://kadro.co/${item.thumb}`}
                                                    onClick={this.showHide}
                                                />)
                                        }
                                        {
                                            studio_photos.length > 2 &&
                                            <div className={styles.exImages}>
                                                <b> مشاهده {(studio_photos.length)} تصویر آتلیه </b>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className={styles.photographyPrice}>
                                <div className={styles.price}>
                                    <p>هزینه پکیج</p>
                                    <div>
                                        {package_original_price > 0 &&
                                            <div>
                                                <p className={styles.DiscoutDivRowP}>{active_coupon_value}٪ تخفیف برای {active_coupon_capacity} نفر</p>
                                                <p className={styles.OriginalpriceValue}>{new Intl.NumberFormat().format(Number(package_original_price))}</p>
                                            </div>
                                        }
                                        <p className={styles.priceValue}>{new Intl.NumberFormat().format(Number(package_price))}<span className={styles.currencyType}>تومان</span></p>
                                    </div>
                                </div>
                                {isStudio && <div className={styles.green}> {stduio_address_detail} </div>}
                                {/* <div className={styles.desc}>
                                     {
                                         package_percent > 0 ?
                                         `%${package_percent} بیشتر (سطح: ${grade})`
                                         : package_percent < 0 ?
                                         `%${package_percent * (-1)} کمتر (سطح: ${grade})`
                                         :
                                         ''
                                    }
                                   <span>  </span>
                                </div> */}
                            </div>
                            <div className={styles.photographyPrice}>
                                <div className={styles.price}>
                                    <p>رفت و آمد</p>
                                    {!this.props.project.data.skip_location && <p>{ new Intl.NumberFormat().format(Number(price))} <span className={styles.currencyType}>تومان</span></p>}
                                    {this.props.project.data.skip_location &&<p><span className={styles.currencyType}>محاسبه بعد از ثبت مکان</span></p>}
                                </div>
                            </div>
                            {photographer_uid === photographerSelected && (
                                <div className={styles.trustLine}>
                                    تضمین جایگزینی رایگان در صورت نارضایتی
                                </div>
                            )}
                            <div
                                className={`${styles.btnSelect} col-12 ${photographer_uid === photographerSelected ? styles.selected : ''}`}
                                onClick={this.returnId(photographer_uid)}
                            > {photographer_uid === photographerSelected && this.props.isRecommended ? 'ادامه با این متخصص' : photographer_uid === photographerSelected ? 'تأیید مجدد انتخاب' : 'انتخاب'}<i className="fa fa-arrow-left" aria-hidden="true" style={{ marginRight: '5px' }}> </i>
                            </div>
                            <div className={styles.tradeoffLine}>
                                {tradeoffText()}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        state,
        project: state.project,
    };
};
export default connect(mapStateToProps, { putData, changeData, unchangeData, getPhotographersEq })(withRouter(Card));
